<div class="warning-overlay" *ngIf="isVisible">
  <div class="warning-modal">
    <div class="warning-header">
      <h3>Warning!</h3>
    </div>
    <div class="warning-content">
      <p>{{ message }}</p>
    </div>
    <div class="back-to-dashboard">
      <a [href]="dashboardUrl">
        <button class="back-to-dashboard-btn">
          Back to Dashboard
        </button>
      </a>
    </div>
  </div>
</div>
